export default __webpack_public_path__ + "static/media/insightdata_tableaudebord.11536aa1.svg";